import { render } from "./UploadPomsContent.vue?vue&type=template&id=465eeacf&scoped=true"
import script from "./UploadPomsContent.vue?vue&type=script&lang=js"
export * from "./UploadPomsContent.vue?vue&type=script&lang=js"

import "./UploadPomsContent.vue?vue&type=style&index=0&id=465eeacf&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-465eeacf"]])

export default __exports__